export function normalizeBusinessType(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function openingHoursFromText(value) {
  const weekdayDescriptions = String(value || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (!weekdayDescriptions.length) {
    return { openingHoursJson: null, openingHoursSummary: null };
  }

  const joined = weekdayDescriptions.join(' | ');
  return {
    openingHoursJson: { weekdayDescriptions },
    openingHoursSummary: joined.length > 255 ? `${joined.slice(0, 252)}...` : joined,
  };
}
